<template>
  <div class="mno_base_packets">
    <div class="row response_table">
            <table>
                <thead style="height: 50px; flex:0; display: inline-block">
                    <tr>
                        <th scope="col" >
                            {{ translate('traffic_packet_list.mno_base_packet.mno_name') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.name') }}
                        </th>
                        <th scope="col" style="width: 50px">
                            {{ translate('traffic_packet_list.mno_base_packet.region') }}
                        </th>
                        <th scope="col" style="width: 50px">
                            {{ translate('traffic_packet_list.mno_base_packet.traffic_limit') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.type') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.billing_type') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.period_type') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.cost') }}
                        </th>
                        <th scope="col" style="width: 50px">
                            {{ translate('traffic_packet_list.mno_base_packet.status') }}
                        </th>
                        <th scope="col">
                            {{ translate('traffic_packet_list.mno_base_packet.ts_create') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item,key) in items"
                        :key="key"
                    >
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.mno_name')" >
                            {{ item.mno_name }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.name')" >
                            {{ item.name }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.region')" style="width: 50px">
                            {{ item.region }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.traffic_limit')" style="width: 50px">
                            {{ item.traffic_limit }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.type')">
                            {{ item.type }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.billing_type')">
                            {{ item.billing_type }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.period_type')">
                            {{ item.period_type }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.cost')">
                            {{ item.cost }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.status')" style="width: 50px">
                            {{ item.status }}
                        </td>
                        <td :data-label="translate('traffic_packet_list.mno_base_packet.ts_create')">
                            {{ get_date(item.ts_create) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


  </div>
</template>

<script>


export default {
  name: 'MnoBasePackets',
  components: {

  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      load: true,
      items: {}
    }
  },

  created () {
    this.get_mno_base_packets()
  },

  methods: {
    get_mno_base_packets(){
      this.$http.v1.getMnoBasePackets((response) => {
        this.items = response.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .mno_base_packets{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
